import React, { useEffect, useState } from "react";
import {
    Modal,
    Box,
    Typography,
    Card,
    CardContent,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    IconButton,
    AppBar,
    Tab, Tabs,
    Toolbar,
    Paper,
    TableContainer,
    Checkbox,
    CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import Stack from '@mui/material/Stack';
// import Header from '../partials/header';
// import LeftSidebar from '../partials/leftSidebar';
import sitesIcon from '../../assets/images/icon/sites.svg';
import OptionIcon from '../../assets/images/icon/Option.svg';
import customersIcon from '../../assets/images/icon/customers.svg';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { TextField } from "formik-material-ui";
// import InfoHoverTooltip from "@/components/Tooltips/InfoHover";
import { useNavigate } from "react-router-dom";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useDropzone } from "react-dropzone";
import { postFileMethod, postMethod } from "../../../services/apiService";
import axios from "axios";
import UploadIn from "../../../assets/images/icon/uploadIcon.svg"
import { ToastContext, useToastContext } from "../../../context/toastContext";
import { clearStorageAndCookies } from "../../../services/authService";
interface Data {
    name: string;
    quantity: number;
    createdTime: number;
    activationTime: number;
    expiryTime: number;
    status: number;
    licenseType: number;
    analyticType?: number;  // Optional if not all objects have it
}

interface ValidatedDataItem {
    key: string;
    partner: string;
    data: Data;
}
const rowsData = [
    {
        detail: "-",
        file: "-",
        uploadDate: "-",
        status: "-",
        createdOrders: "-",
        createdL: "-",
        createdC: "-",

    },
    {
        detail: "-",
        file: "-",
        uploadDate: "-",
        status: "-",
        createdOrders: "-",
        createdL: "-",
        createdC: "-",
    },
];

function LicenceTabThree(props: any) {

    const { setToast } = useToastContext() as ToastContext;
    const navigate = useNavigate();



    const [selectedRows, setSelectedRows] = useState<number[]>([]);
    const [rows, setRows] = useState(rowsData);

    const [file, setFile] = useState<File | null>(null);
    const [isValidating, setIsValidating] = useState(false);
    const [isApplying, setIsApplying] = useState(false);
    const [uploadResponse, setUploadResponse] = useState<string>("");
    const [validatedData, setValidatedData] = useState<ValidatedDataItem[]>([]);

    const isLoading = isValidating || isApplying;

    const onDrop = (acceptedFiles: File[]) => {
        setFile(acceptedFiles[0]);
    };


    const { getRootProps, getInputProps } = useDropzone({ onDrop, disabled: isLoading });


    const handleFileUpload = async () => {
        if (!file) return;

        setIsValidating(true);
        try {
            const formData = new FormData();
            formData.append("license", file);

            const response: any = await postFileMethod("distributor/license/validate", formData);

            if (response?.status === 200) {
                setToast(response?.data?.message, "success");
                setValidatedData(response.data.result);
            } else {
                setToast(response?.data?.message || "Validation failed", "error");
            }
        } catch (error) {
            console.error("Error validating license file", error);
            setToast("Failed to validate license file", "error");
        } finally {
            setIsValidating(false);
        }
    };

    useEffect(() => {
        handleFileUpload();
    }, [file]);

    const handleApply = async () => {
        if (!file) return;

        setIsApplying(true);
        try {
            const formData = new FormData();
            formData.append("license", file);

            const response: any = await postFileMethod("distributor/license", formData);
            if (response?.status === 200) {
                setToast(response?.data?.message, "success");
                props.setActiveTab(0);
            } else {
                setToast(response?.data?.message || "Failed to apply license", "error");
            }
        } catch (error) {
            console.error("Error applying license", error);
            setToast("Failed to apply license", "error");
        } finally {
            setIsApplying(false);
        }
    }

    function convertTimestampToDate(timestamp: number): string {
        const formattedDate = new Date(timestamp).toLocaleString();
        return formattedDate.replace(',', '  |');
    }


    const handleCancel = () => {
        setValidatedData([])
        setFile(null)

    }


    return (
        <>
            <Box sx={{ display: "flex", alignContent: "space-between", justifyContent: "space-between", gap: "32px", padding: "1rem" }}>

                <div style={{
                    // border: "2px solid #ccc",
                    padding: "20px",
                    width: "100%",
                    marginBottom: "20px",
                    textAlign: "center",
                }}>
                    {/* Drag and drop or browse */}
                    <div
                        {...getRootProps()}
                        style={{
                            border: "1px dashed #ccc",
                            padding: "20px",
                            width: "100%",
                            height: "200px",
                            marginBottom: "20px",
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignContent: "center",
                            alignItems: "center",
                            cursor: isLoading ? "not-allowed" : "pointer"
                        }}
                    >
                        <input {...getInputProps()} />
                        {isValidating ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                <CircularProgress size={40} sx={{ color: '#17B2EB' }} />
                                <Typography sx={{ color: '#17B2EB' }}>Validating license file...</Typography>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                                <img src={UploadIn} alt="" width={24} height={24} />
                                <p style={{ color: "#17B2EB", margin: 0 }}> Drag files or click to browse</p>
                            </Box>
                        )}
                    </div>

                    {/* If a file is selected, show the upload button */}
                    {file && (
                        <div>
                            <p>Selected file: {file.name}</p>

                        </div>
                    )}

                    {/* Show the upload response message */}
                    {uploadResponse && <p>{uploadResponse}</p>}
                </div>
            </Box>
            <Box>
                <h2>Imports Licenses List</h2>
            </Box>
            <TableContainer
                component={Paper}
                sx={{ backgroundColor: "#03171f", padding: "1rem" }}
            >
                <Table sx={{ backgroundColor: "#03171f", border: "1px solid #313838" }}>
                    {/* Table Header */}
                    <TableHead>
                        <TableRow style={{ borderBottom: "2px solid #313838" }}>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            />
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Key
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Name
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Quantity
                            </TableCell>

                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Created On
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Activation Date
                            </TableCell>

                            {/* <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Site / Device
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Feature
                            </TableCell> */}
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Expiry Date
                            </TableCell>
                            {/* <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Order ID
                            </TableCell> */}



                        </TableRow>
                    </TableHead>

                    {/* Table Body */}
                    <TableBody>
                        {validatedData && validatedData.length > 0 ? (
                            validatedData?.map((row, index) => (
                                <TableRow key={index}>
                                    {/* Checkbox Column */}
                                    <TableCell
                                        sx={{
                                            color: "#B4B7B8",
                                            borderColor: "#313838",
                                            width: "50px",
                                        }}
                                    >
                                        {/* Add your checkbox or any content here */}
                                    </TableCell>
                                    {/* Data Columns */}
                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {row.key}
                                    </TableCell>
                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {row.data.name}
                                    </TableCell>
                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {row.data.quantity}
                                    </TableCell>
                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {convertTimestampToDate(row.data.createdTime)}
                                    </TableCell>
                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {convertTimestampToDate(row.data.activationTime)}
                                    </TableCell>

                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {convertTimestampToDate(row.data.expiryTime)}
                                    </TableCell>

                                </TableRow>
                            ))
                        ) : (
                            // Display a row with "-" if no data exists
                            <TableRow>
                                <TableCell
                                    colSpan={6} // Span across all columns
                                    sx={{
                                        textAlign: "center",
                                        color: "#B4B7B8",
                                        borderColor: "#313838",
                                    }}
                                >
                                    {"-"}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>

                </Table>
            </TableContainer>
            {validatedData && validatedData.length > 0 && (
                <div style={{ display: "flex", justifyContent: "space-between", padding: "0 20px" }}>


                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 2,
                            mt: 3,
                        }}
                    >

                        <button
                            style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
                            className="add-btn"
                            onClick={handleCancel}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                    </Box>
                    <Box

                        sx={{

                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 2,
                            mt: 3,
                        }}
                    >

                        <button
                            style={{ cursor: isLoading ? "not-allowed" : "pointer", display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                            className="add-btn"
                            onClick={handleApply}
                            disabled={isLoading}
                        >
                            {isApplying && <CircularProgress size={16} sx={{ color: 'inherit' }} />}
                            Apply
                        </button>
                    </Box>
                </div>



            )}
        </>
    )
}

export default LicenceTabThree